import styled from "styled-components";
import { Flex } from "discover.medical.react-component-library";

export const Container = styled(Flex)`
  height: 100vh;
`;

export const Main = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Content = styled(Flex)`
  height: 100%;
  width: 100%;
  padding: ${({ theme }) => theme.space.lg}
    ${({ theme }) => theme.space.gutter.base};
  margin: 0 auto;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.space.xl} ${({ theme }) => theme.space.md};
  }
`;
